module.exports = __webpack_public_path__ + "static/briopreview-952e86ee6a2918fbcceeb7186f14a801.jpg";